import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../components/ui.module';
import { EditModeContextWithOriginalState } from '../../../types';

type CellParams = ICellRendererParams & {
  isEditing: () => boolean;
  isSaving: () => boolean;
  editContext: () => EditModeContextWithOriginalState;
};

@Component({
  selector: 'app-cell-subscriptions-trial',
  imports: [UiModule, NgSelectModule, FormsModule, MatTooltipModule],
  templateUrl: './cell-subscriptions-trial.component.html',
  styleUrl: './cell-subscriptions-trial.component.scss',
})
export class CellSubscriptionsTrialComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }

  getTrial(trialEndDate?: Date) {
    const returnValue = {
      endDate: trialEndDate,
      tooltip: trialEndDate ? 'Trial ends on ' + trialEndDate.toLocaleDateString() : 'No trial',
      text: 'No trial',
      editable: true,
    };

    if (trialEndDate === null || trialEndDate === undefined) {
      return returnValue;
    }

    const dateNow = new Date();
    if (dateNow < trialEndDate) {
      const timeDiff = trialEndDate.getTime() - dateNow.getTime();
      const dayDifference = Math.floor(timeDiff / (1000 * 3600 * 24));
      returnValue.text = `${dayDifference} days remaining`;
      returnValue.editable = false;
    } else {
      returnValue.text = `Ended on ${trialEndDate.toLocaleDateString()}`;
      returnValue.tooltip = 'Trial ended';
      returnValue.editable = true;
    }

    return returnValue;
  }
}
